import React from "react";
import { Popover } from "antd";

// Same palette PersonnelMarker uses -- a cluster is coloured by the WORST
// status among its members (see personnelClustering.worstStatus), so a group
// containing someone who has stopped reporting cannot read as all-green.
const STATUS_COLORS = {
  active: "#52c41a",
  warning: "#faad14",
  sos: "#ff4d4f",
  offline: "#8c8c8c",
};

export const CLUSTER_SIZE = 28;

/**
 * One badge standing in for several personnel markers that are too close
 * together to read apart at the current zoom.
 *
 * Click LISTS the members, rather than expanding them in place or forcing a
 * zoom: it matches what the other clickable things on this canvas already do
 * (stations and machines open a popover on click), it works on a display the
 * operator may not want to re-frame, and picking a name from the list runs the
 * ordinary personnel selection so the follow-on behaviour is unchanged.
 *
 * `sos`/`warning` personnel are never inside one of these -- they are excluded
 * from clustering upstream and always render as their own marker.
 */
const PersonnelCluster = ({
  group,
  isOpen,
  setOpenClusterKey,
  onPersonnelClick,
}) => {
  const color = STATUS_COLORS[group.status] || STATUS_COLORS.offline;

  const content = (
    <div style={{ maxHeight: 240, overflowY: "auto", minWidth: 120 }}>
      {group.members.map((member) => {
        const memberColor =
          STATUS_COLORS[member.status] || STATUS_COLORS.offline;
        return (
          <div
            key={member.id}
            onClick={(e) => {
              e.stopPropagation();
              setOpenClusterKey(null);
              onPersonnelClick(member.id);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 2px",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: memberColor,
                flexShrink: 0,
              }}
            />
            <span style={{ fontSize: 12 }}>{member.name}</span>
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      style={{
        position: "absolute",
        left: group.x,
        top: group.y,
        transform: "translate(-50%, -50%)",
        pointerEvents: "auto",
        cursor: "pointer",
      }}
    >
      <Popover
        content={content}
        title={`${group.count} 位人員`}
        trigger="click"
        open={isOpen}
        onOpenChange={(open) => setOpenClusterKey(open ? group.key : null)}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            setOpenClusterKey(isOpen ? null : group.key);
          }}
          style={{
            width: CLUSTER_SIZE,
            height: CLUSTER_SIZE,
            borderRadius: "50%",
            backgroundColor: color,
            border: "2px solid #fff",
            boxSizing: "border-box",
            boxShadow: `0 2px 6px ${color}88`,
            color: "#fff",
            fontSize: 12,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {group.count}
        </div>
      </Popover>
    </div>
  );
};

export default PersonnelCluster;
